import { GridFilterModel, GridSlotsComponent } from "@mui/x-data-grid";
import React from "react";
import { DATA_GRID_SLOTS } from "../../BasicComponents/DataGridSlots";
import { CustomDataGridWithMultipleFiltersProps } from "../Interfaces/CustomDataGrid.interfaces";
import { CustomDataGridToolbar } from "./CustomDataGridToolbar";

export const customDataGridSlots = (
  displayFilterPanel: () => React.JSX.Element,
  filterModel: GridFilterModel,
  props: Readonly<CustomDataGridWithMultipleFiltersProps>
): Partial<GridSlotsComponent> => {
  const { slots = {}, isError, toolbarConfig = {}, exportCsvButtonProps } = props;
  const { noRowsOverlay, toolbar, filterPanel } = slots;
  const { disableGridToolbarCustomFilterPanel } = toolbarConfig;

  return {
    ...slots,
    noRowsOverlay: noRowsOverlay ?? DATA_GRID_SLOTS.noRowsOverlay(Boolean(isError)),
    toolbar:
      toolbar ??
      (() => (
        <CustomDataGridToolbar
          exportCsvButtonProps={exportCsvButtonProps}
          filterModel={filterModel}
          toolbarConfig={toolbarConfig}
        />
      )),
    filterPanel: disableGridToolbarCustomFilterPanel ? undefined : (filterPanel ?? displayFilterPanel)
  };
};
